import { render, staticRenderFns } from "./quick-nav.vue?vue&type=template&id=1ed5b8d3&scoped=true"
import script from "./quick-nav.vue?vue&type=script&lang=js"
export * from "./quick-nav.vue?vue&type=script&lang=js"
import style0 from "./quick-nav.vue?vue&type=style&index=0&id=1ed5b8d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5b8d3",
  null
  
)

export default component.exports